<!-- Top anchor -->

<div #home class="top-anchor"></div>

<!-- Home -->

<div class="nav-container box-shadow-lower fixed-top">
  <div class="topbar">
    <div class="topbar-elements">
      <span>(+40)000 000000</span>
      <span *ngIf="!isLogged"><a routerLink='/registration'>Sign Up</a></span>
      <span *ngIf="!isLogged"><a routerLink='/login'>Log in</a></span>
      <span *ngIf="isLogged"><a (click)="logout()" routerLink='/'>Log Out</a></span>
    </div>
  </div>

  <!-- NAVBAR START -->
  <nav class="navbar navbar-expand-lg navbar-light bg-white logo-bar">
    <div class="container-fluid justify-content-lg-center">
        <a class= "navbar-brand a-link" (click)="navTo(home)"><img class="logo-top d-inline-block align-text-top mg-2" width="130px" src="assets/img/emdr official.svg" alt="EMDR therapy logo"/></a>
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse flex-lg-grow-0" id="navbarSupportedContent">
        <ul class="navbar-nav">  
          <li class="nav-item">
            <a class="nav-link clickable" (click)="navTo(home)">Home</a>
          </li>
          <li class="nav-item">
            <a class="nav-link clickable" (click)="navTo(therapy)">EMDR Therapy</a>
          </li>
          <li class="nav-item">
            <a class="nav-link clickable" (click)="navTo(help)">Professional Help</a>
          </li>
          <li class="nav-item">
            <a class="nav-link clickable" (click)="navTo(faqs)">FAQs</a>
          </li>
          <li class="nav-item">
            <a class="nav-link clickable" (click)="navTo(contact)">Contact Us</a>
          </li>
          <li class="nav-item d-lg-inline-flex align-items-lg-center">
            <div *ngIf="isLogged" matRipple><button routerLink='/chat' class="start-button" mat-raised-button color="#20BEA7">Start Therapy</button></div>
            <button *ngIf="!isLogged" routerLink='/login' class="start-button" mat-raised-button color="#20BEA7">Start Therapy</button>
          </li>
        </ul>
      </div>
    </div>
  </nav>
  <!-- NAVBAR END -->


</div>

<div (window:resize)="onResize($event)" [ngStyle]="screenWidth > 992 ? {'background-image': 'url(' + herosrc + ')'}:{'background-image': 'linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),url(' + herosrc + ')'}" alt="girl with laptop attends EMDR session" class="home-body d-flex flex-column align-items-center justify-content-center">
  <h1 class="tablet-title text-center">EMDR Therapy</h1>
  <p class="tablet-motto text-center">Heal from the past to succeed in the future.</p>
  <button *ngIf="isLogged" routerLink='/chat' class="tablet-start-button start-button" mat-raised-button color="#20BEA7">Start Therapy</button>
  <button *ngIf="!isLogged" routerLink='/login' class="tablet-start-button start-button" mat-raised-button color="#20BEA7">Start Therapy</button>
  <div class="animated-motto">
    <h4 class="motto text-start">Heal from the past in order to succeed in the future.</h4>
  </div>
</div>


<!-- EMDR Therapy -->

<div [ngStyle]="{'background-image':'linear-gradient(to right, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.2)), url(' + descsrc + ')'}" alt="soothing texture" class="therapy-description container-full d-flex align-items-center" >
  <div #therapy class="section-anchor" id="therapyanchor"></div>
    <div class="description-container">
        <div class="title1">How EMDR Therapy cures you</div>
        <div class="description1">“EMDR Therapy changes maladaptive neural networks by connecting the traumatic memory with new information. The distressing thoughts and emotions are blended with new positive thoughts and emotions; embodied awareness allows frozen sensations in the body to resolve through healing movements.”</div>
    </div>
</div>


<!-- Professionals -->

<div class="professionals-container container-full text-center">
  <div #help class="section-anchor"></div>
    <h2 class="title2">Seek Help from our Professionals</h2>
    <p class="subtitle">Our team of properly trained professionals is ready to guide you on your healing journey. Don’t hesitate to contact your preferred therapist to discuss details and set up an appointment </p> 
    <div class="cards row">
      <div class="col-12 col-lg-4 card-container">
        <div class="professional-card text-start">
          <h3 class="card-title">Jane Smith</h3>
          <p class="card-description">“As a therapist, you have to remember that for each patient you may be the only person truly capable of hearing and holding their pain. This is sacred. ”</p>
          <div [ngStyle]="{'background-image': 'url(' + card1src + ')'}" alt="therapist smiling with kindness" class="card-photo photo1"></div>       
        </div>       
      </div> 
      
      <div class="col-12 col-lg-4 card-container">
        <div class="professional-card text-start">
          <h3 class="card-title">John Lakin</h3>
          <p class="card-description">“A healing journey takes time, it requires dedication, it will sometimes hurt and it requires sacrifice but in the end, it will all be worth it.”</p>
          <div [ngStyle]="{'background-image': 'url(' + card2src + ')'}" alt="therapist smiling with kindness" class="card-photo photo2"></div>       
        </div>     
      </div>

    <div class="col-12 col-lg-4 card-container">
      <div class="professional-card text-start">
        <h3 class="card-title">Sarah Pearlman</h3>
        <p class="card-description">“Strength doesn't come from what you can do, but from overcoming the hardships you once thought will stick with you forever.”</p>
        <div [ngStyle]="{'background-image': 'url(' +card3src + ')'}" alt="therapist smiling with kindness" class="card-photo photo3"></div>       
      </div>      
    </div>

  </div> 
</div> 


<!-- FAQs -->

<div class="faqs">
  <div #faqs class="section-anchor"></div>
    <div class="title3">Frequently Asked Questions</div>

      <mat-expansion-panel class="faqs-panel" [expanded]="true">
        <mat-expansion-panel-header>
          <mat-panel-title> What is EMDR therapy?</mat-panel-title>
        </mat-expansion-panel-header>
        <p>EMDR (Eye Movement Desensitization and Reprocessing) is a psychotherapy technique that was developed to help people cope with the pain of traumatic memories (Shapiro, 1989a, 1989b). According to Shapiro's (2001) Adaptive Information Processing model, EMDR counseling helps people access and interpret painful memories and other negative life experiences in order to reach an adaptive resolution.</p>
      </mat-expansion-panel>

      <mat-expansion-panel class="faqs-panel">
        <mat-expansion-panel-header>
          <mat-panel-title> Who can benefit from EMDR therapy?</mat-panel-title>
        </mat-expansion-panel-header>
        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</p>
      </mat-expansion-panel>

      <mat-expansion-panel class="faqs-panel">
        <mat-expansion-panel-header>
          <mat-panel-title> How does EMDR treatment work?</mat-panel-title>
        </mat-expansion-panel-header>
        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</p>
      </mat-expansion-panel>

      <mat-expansion-panel class="faqs-panel">
        <mat-expansion-panel-header>
          <mat-panel-title> How effective is EMDR?</mat-panel-title>
          <!-- <mat-panel-description></mat-panel-description> -->
        </mat-expansion-panel-header>
        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</p>
      </mat-expansion-panel>

      <mat-expansion-panel class="faqs-panel">
        <mat-expansion-panel-header>
          <mat-panel-title> How many sessions will it take?</mat-panel-title>
          <!-- <mat-panel-description></mat-panel-description> -->
        </mat-expansion-panel-header>
        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</p>
      </mat-expansion-panel>

</div>  

<!-- Contact -->

<div class="contact-body">
  <div #contact class="section-anchor"></div>
    <div class="title4">Contact Us</div>
    <div class="subtitle-2">For further details don’t hesitate to contact us and our staff will get back to you with a reply as soon as possible</div>

    <div class="form-container row">
        <div [ngStyle]="{'background-image': 'url(' +contactsrc + ')'}" alt="doodle of a screen surrounded by social media icons" class="contact-image col-12 col-lg-6"></div>
        <div class="contact-form col-12 col-lg-6">
          <form (ngSubmit)="formValidation()">
            <div class="form-row1 row justify-content-lg-between"> 
              <input [ngStyle]="{'border-color': usernameErr}" required class="row1 col-12 col-lg-6 margin-bottom-lg-15" type="text" name="username" placeholder="Name" id="username" [(ngModel)]="username">
              <input [ngStyle]="{'border-color': phoneErr}" required class="row1 col-12 col-lg-6" type="tel" name="Phone" placeholder="Phone" id="phone" [(ngModel)]="phonenumber">
            </div>
            <input [ngStyle]="{'border-color': mailErr}" required class="row2" type="text" name="Email" placeholder="Email" id="email" [(ngModel)]="email">
            <textarea [ngStyle]="{'border-color': messageErr}" required class="row3" type="text" name="Message" placeholder="Message" id="message" [(ngModel)]="message"></textarea>
            <div class="form-bottom">
              <div>
                <p *ngIf="buttonClicked && formError" class="error">{{formError}}</p> 
                <p *ngIf="buttonClicked && emailSent" class="successful-mail">Mail sent succesfully!</p>
              </div>
              <div class="button-container" matRipple ><button class="send-button" mat-raised-button color="#20BEA7">Send Message</button></div>
            </div>
            
          </form>
        </div> 

    </div>  

  </div>  
  
  

  <!-- Footer -->

  <footer class="footer">

    <div class="row">
      <div class="content-left col-md-6">
       <a class="a-link" (click)="navTo(home)"><img class="logo" src="assets/img/emdr official.svg" alt="EMDR therapy logo"/></a>
        <div class="description">Provides easy access to revolutionary therapy from any environment the user feels comfortable in.</div>
      </div>

      <div class="content-middle col-md-3">
          <a (click)="navTo(home)" class="footer-link">Home</a>
          <a (click)="navTo(therapy)" class="footer-link">EMDR Therapy</a>
          <a (click)="navTo(help)" class="footer-link">Professional Help</a>
          <a (click)="navTo(faqs)" class="footer-link">FAQs</a>
          <a (click)="navTo(contact)" class="footer-link">Contact Us</a>
      </div>

      <div class="content-right col-md-3">
        <a class="footer-link" href="tel:+403-452-63556">(+40) 345 263556</a>
        <a class="footer-link" href="tel:+403-452-63556">(+40) 345 263556</a>
        <a class="footer-link" href="mailto:email@mail.com">email@mail.com</a>
      </div>   
    </div>

  </footer>